const SupplierOrderStatus = Object.freeze({
  CLOSED: 'CLO',
  CANCELLED: 'CAN'
})

export function isClosedOrCancelled(status) {
  return Object.values(SupplierOrderStatus).includes(status)
}

export default SupplierOrderStatus
